module.exports = __webpack_public_path__ + "img/icon-competence-5.22fd6d16.svg";